export default "__VITE_ASSET__zUdY_Bsd__"